import { Injectable } from '@angular/core';
import { TableAdvencedFilterModel } from './table-filter-component.model';
import { MatTableDataSource } from '@angular/material/table';

@Injectable({
    providedIn: 'root',
})
export class TableFilterService {
    model: TableAdvencedFilterModel;

    constructor() {}

    setModel(dataSource: any[]) {
        // Define the correct TypeScript type for our map
        const uniqueValuesMap: Record<string, Record<string, boolean>> = {};

        // Populate the map
        dataSource.forEach((obj: Record<string, string | null>) => {
            Object.entries(obj).forEach(([key, value]) => {
                if (value !== null) {
                    if (!uniqueValuesMap[key]) {
                        uniqueValuesMap[key] = {}; // Initialize object for this key
                    }
                    uniqueValuesMap[key][value] = false; // Default boolean value
                }
            });
        });

        this.model = {
            filters: uniqueValuesMap,
        };
    }

    getFilterValues(key: string): Record<string, boolean> {
        return this.model.filters[key];
    }

    applyFilter(result: any): void {}

    getSelectedFilterValuesAsArray(): any {
        return Object.keys(this.model.filters).reduce((acc, category) => {
            // For each category, filter the keys where the value is true
            acc[category] = Object.keys(this.model.filters[category]).filter(
                key => this.model.filters[category][key]
            );
            return acc;
        }, {});
    }
}
